export default __webpack_public_path__ + "static/media/STL_GRC_Certificate_1.0f5698a3.jpg";